<template>
  <div class="section-200 position-relative">
    <ImgComparisonSlider :direction="direction">
      <!-- eslint-disable -->
      <img
          slot="first"
          class="w-100"
          :alt="findAttributeOnSiteInfo('site_name')[0]"
          :src="imageBefore"
      />
      <img
          slot="second"
          class="w-100"
          :alt="findAttributeOnSiteInfo('site_name')[0]"
          :src="imageAfter"
      />
      <!-- eslint-enable -->
    </ImgComparisonSlider>
  </div>
</template>

<script>
import mImg from "../Tags/Img";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {ImgComparisonSlider} from '@img-comparison-slider/vue';

export default {
  name: "Section200",
  components: {
    mImg,
    ImgComparisonSlider,
  },
  props: {
    imageBefore: {
      default: 'https://picsum.photos/1280/720'
    },
    imageAfter: {
      default: 'https://picsum.photos/1280/720'
    },
    direction: {
      default: 'horizontal',
      options: ['vertical', 'horizontal']
    }
  },
  methods: {findAttributeOnSiteInfo},
  mounted() {
  }
}
</script>

<style scoped></style>